// User dropdown toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  var userDropdownToggle = document.querySelector('.ssw-dropdown-toggle');
  
  if (userDropdownToggle) {
    userDropdownToggle.addEventListener('click', function(event) {
      event.preventDefault();
      
      var dropdown = this.nextElementSibling;
      if (dropdown.style.display === 'block') {
        dropdown.style.display = 'none';
        document.removeEventListener('click', closeDropdown);
      } else {
        dropdown.style.display = 'block';
        setTimeout(function() {
          document.addEventListener('click', closeDropdown);
        }, 0);
      }
      
      function closeDropdown(e) {
        if (!userDropdownToggle.contains(e.target)) {
          dropdown.style.display = 'none';
          document.removeEventListener('click', closeDropdown);
        }
      }
    });
  }
});